import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-epin-table',
  templateUrl: './epin-table.component.html',
  styleUrls: ['./epin-table.component.css']
})
export class EpinTableComponent {
  
  @Input() isLoading : boolean = false;
  @Input() message : String = "";
  @Input() epinListData : Array<any> = [];
  @Output() updateSort = new EventEmitter<Sort>();
  @Output() onItemClickEmitter = new EventEmitter<Sort>();
  
  isMobile : boolean = false;

  constructor(
    public globalservice : GlobalService
  ){}

  ngOnInit(){
    this.isMobile = this.globalservice.isMobile();
  }

  onItemClick(data:any){
    this.onItemClickEmitter.emit(data);
  }
  sortData(sort:Sort){
    this.updateSort.emit(sort);
  }

}
